import CameraSvg from '@assets/images/svg/camera.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface CameraIconProps {
    size?: number;
    color?: string;
}

export function CameraIcon({ size = 24, color = '#333333' }: CameraIconProps) {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <CameraSvg
                width={size}
                height={size}
                color={color}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default CameraIcon;

